<template>
  <v-app id="inspire">
    <div class="container">
      <v-flex xs12 sm6 offset-sm3 v-if="formStatus != 2">
        <v-card>
          <v-card-title class="blue white--text">
            <span class="headline">Request New Offer Form</span>

            <flash-message class="myCustomClass" id="myCustomClass"></flash-message>

            <v-spacer></v-spacer>
            {{deal.deal_name}}
          </v-card-title>

          <v-card-text v-if="formStatus === 0">
            <p>If you believe a better offer can be made for this submission, You may respond to this email with any questions, or stips:</p>
            <v-form onsubmit="return false;" ref="form" lazy-validation>
              <v-flex xs12 sm12 md12>
                <!-- <div class="large-12 medium-12 small-12 filezone">
                  <input type="file" id="files" ref="files" style="margin-left: -270px;" multiple v-on:input="handleFiles()" />
                  <p>
                    Drop your files here
                    <br />or click to search
                  </p>
                </div> -->

                <div v-for="(file, key) in files" class="file-listing" :key="key">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                      <img
                        class="preview"
                        v-bind:ref="'preview'+parseInt(key)"
                        height="70"
                        width="100"
                      />
                      <p>{{file.fileUploaded.name}}</p>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-autocomplete
                        v-model="file.category_id"
                        :rules="[v => !!v || 'File Category is required']"
                        :items="categories"
                        item-text="file_category_name"
                        item-value="id"
                        label="File Category"
                        persistent-hint
                        autocomplete
                        required
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>

                  <div class="success-container" v-if="file.id > 0">Success</div>
                  <div class="remove-container" v-else>
                    <a class="remove" v-on:click="removeFile(key)">Remove</a>
                  </div>
                </div>
              </v-flex>
              <!--Files Upload-->

              <div class="col-md-12">
                <!--<label for="note">Message to us</label>-->
                <vue-editor
                  placeholder="Message to us"
                  id="note"
                  v-model="iso_message"
                  :editorToolbar="customToolbar"
                ></vue-editor>
              </div>

              <v-btn color="primary" @click="sendNotification" :disabled="progressModel">Submit</v-btn>
            </v-form>
            <!--<progress-model v-if="progressModel"></progress-model>-->
          </v-card-text>
          <v-card-text v-if="formStatus === 1">
            <p>Your request for a new offer has been submitted. We will get back to you shortly.</p>
            <br />
            <p>Thank you,</p>
            <!-- <v-btn color="primary" @click="logout">
              DONE
            </v-btn>-->
          </v-card-text>
          <v-card-text v-if="formStatus === 4">
            <p><span class="material-icons">error_outline</span> This offer was already accepted for contract. Please reply through the email for any change/question.</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <div class="text-xs-center" v-if="formStatus === 2">
        <v-flex>
          <span class="material-icons">error_outline</span> <p><b>Sorry, Page not found.</b></p>
        </v-flex>
      </div>
      <div class="text-xs-center">
        <v-dialog v-model="progressModel" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Please stand by
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { URL } from "../../env";

export default {
  components: {
    VueEditor,
  },
  created(){
    this.getLenderData();
  },
  data() {
    return {
      formStatus: 0,
      user: {
        id: this.$route.query.user_id,
        name: this.$route.query.user_name,
      },
      deal: {
        deal_id: null,
        deal_name: '',
        deal_lender_id: null,
        deal_unique_id: null,
        company_id: null
      },
      progressModel: false,
      uploaded: false,
      categories: [],
      category_id: null,
      files: [],
      iso_message: "",
      image: "",
      uploadedFiles: "",
      // Set Custom toolbar for vue editor
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        [{ direction: "rtl" }],
        ["clean"]
      ]
    };
  },

  mounted() {
    this.getCategories();
  },
  methods: {
    async getLenderData(){
      if(!this.$route.query.unique_id){
        this.formStatus = 2;
        return false
      }
      await axios.get(`${URL}/api/get_lender_data/${this.$route.query.unique_id}`).then(resp => {
        if(resp.data.length > 0){
          this.deal.deal_id = resp.data[0].deal_id
          this.deal.deal_name = resp.data[0].deal_name
          this.deal.deal_lender_id = resp.data[0].id
          this.deal.deal_unique_id = resp.data[0].deal_unique_id
          this.deal.company_id = resp.data[0].company_id
          this.slider = resp.data[0].lender_commission_percentage
          this.formStatus = resp.data[0].iso_reply == 1 ? 4 : 0;
        }
      })
    },
    async getCategories() {
        await axios.get(`${URL}/api/get_file_category`).then(res => {
          this.categories = res.data;
        });
    },

    handleFiles() {
      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({ fileUploaded: uploadedFiles[i], category_id: null });
      }
      this.getImagePreviews();
    },

    //handle image preview
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].fileUploaded.name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function() {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i].fileUploaded);
        } else {
          this.$nextTick(function() {
            this.$refs["preview" + parseInt(i)][0].src =
              "https://www.foot.com/wp-content/uploads/2017/03/placeholder.gif";
          });
        }
      }
    },

    //Remove file
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },

    //Method to submit merchant files
    submitFiles: async function() {
      let vm = this;
      // if (vm.files.length > 0) {
        // if (this.$refs.form.validate()) {
          // for (let i = 0; i < vm.files.length; i++) {
            // if (vm.files[i].fileUploaded.id) {
            //   continue;
            // }
            let formData = new FormData();
            // formData.append("file", vm.files[i].fileUploaded);
            formData.append("user_id", vm.$route.query.iso_user_id);
            formData.append("deal_id", vm.deal.deal_id);
            // formData.append("file_category_id", vm.files[i].category_id);
            formData.append('notify_underwriter', 'OFF');
            await axios
                .post(`${URL}/api/create_deal_file`, formData)
              .then(
                function(data) {
                  // vm.files[i].id = data["data"]["id"];
                  // vm.files.splice(i, 1, vm.files[i]);

                  if (data.data.success) {
                    //Set Flash message
                    vm.flash(data.data.message, "success", {
                      timeout: 4000
                    });

                    vm.uploaded = true;
                  }
                }.bind(this)
              )
              .catch(function(data) {
                //Set Flash message
                // vm.flash("There was an error uploading files.", "error", {
                //   timeout: 4000
                // });
              });
          // }
          vm.files = [];
        // }
      // }

      vm.progressModel = false;
      vm.formStatus = 1;
      //window.close();
    },

    //Merchant Files Upload Functions END
    //***************************************

    sendNotification() {
      let vm = this;
      vm.progressModel = true;
      axios
        .post(`${URL}/api/iso_reject_offer_noti`, {
          //"_token": window.Laravel.csrfToken,
          deal_id: vm.deal.deal_id,
          deal_unique_id: vm.deal.deal_unique_id,
          deal_lender_id: vm.deal.deal_lender_id,
          user_id: vm.user.id,
          iso_user_id: vm.$route.query.iso_user_id,
          iso_name: vm.user.name,
          iso_message: vm.iso_message
        })
        .then(function(response) {
          //Set Flash message
          vm.flash("Message was sent, Thanks!", "success", {
            timeout: 4000
          });

          vm.saveNote();
        })
        .catch(function(error) {});
    },

    //Save Form
    async saveOfferUpdate() {
      let app = this;

      await axios
        .patch(`${URL}/api/update_deal_lender/` + app.deal.deal_lender_id, {
          // _token: window.Laravel.csrfToken,
          deal_id: app.deal.deal_id,
          lender_offer_status: "Request New Offer"
        })
        .then(function(response) {
          if (response.data.success) {
            app.flash(response.data.message, "success", {
              timeout: 3000
            });

            // app.submitFiles();
          }
        })
        .catch(function(error) {
          //Set Flash message
          app.flash("There was an error", "error", {
            timeout: 3000
          });
        });
      await app.submitFiles();
      await axios
        .patch(`${URL}/api/update_submission/` + app.deal.deal_id, {
          deal_status: "Request Price Adjustment",
          deal_next_processor_role: "Credit Analyst"
        })
        .catch(function(error) {
          app.flash("There was an error", "error", {
            timeout: 3000
          });
        });
    },

    //Save Form
    saveNote() {
      let app = this;
      axios
        .post(`${URL}/api/create_sub_note`, {
          deal_id: app.deal.deal_id,
          user_id: app.$route.query.iso_user_id,
          deal_user_note: app.iso_message,
          deal_note_type: "Requested New Offer",
          deal_unique_id: app.deal.deal_unique_id,
          company_id: app.deal.company_id,
          pinned: false
        })
        .then(function(response) {
          app.saveActivity();
        })
        .catch(function(error) {
          //Set Flash message
          app.flash("Error Adding Note", "error", {
            timeout: 3000
          });
        });
    },

    saveActivity() {
      let app = this;

      axios
        .post(`${URL}/api/create_sub_note`, {
          deal_id: app.deal.deal_id,
          user_id: app.$route.query.iso_user_id,
          deal_user_note: "Requested New Offer",
          deal_note_type: "Activity",
          pinned: false
        })
        .then(function(response) {
          app.saveOfferUpdate();
        })
        .catch(function(error) {
          app.flash("Error Adding Note", "error", {
            timeout: 3000
          });
        });
    }
  }
};
</script>


<style scoped>
input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.filezone {
  outline: 2px dashed #2196f3;
  outline-offset: -10px;
  /*background: #ccc;*/
  background: #fafafa;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}

.filezone:hover {
  background: #eeeeee;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 50px 50px 50px;
}

div.file-listing img {
  max-width: 90%;
}

div.file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img {
  height: 100px;
}

div.success-container {
  text-align: center;
  color: green;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}
</style>


<style scoped>
.fileUpload {
  position: relative;
  overflow: hidden;
  margin: 25px;
}

.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}
</style>
